webpackJsonp([184662623972074],{

/***/ 366:
/***/ (function(module, exports) {

	module.exports = {"data":{"TopParagraph":{"html":"<h1>Contact</h1>\n<p>If you want to learn more about our solutions for candidates, political parties and elected politicians then don't hesitate to get in touch using any of the methods below:</p>","frontmatter":{"name":"Contact"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---contact-66233002c78c38fb1ef0.js